import { Component } from '@angular/core';
import { WelcomeCard } from '../../shared/models/card.type';
import { welcomeCards } from '../../shared/information-cards';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { NGXLogger } from 'ngx-logger';
import { RoutingUtils } from 'src/app/routing/routing.utils';
import { environment } from 'src/environments/environment';
import { GtmEvent } from 'src/app/core/services/analytics/analytics.types';

@Component({
  selector: 'app-registered-user',
  templateUrl: './registered-user.component.html',
  styleUrls: ['./registered-user.component.scss'],
})
export class RegisteredUserComponent {
  cards: WelcomeCard[] = welcomeCards;

  currentRoute = '/registered-user';

  paymentLink: string;

  constructor(
    private analyticsService: AnalyticsService,
    private logger: NGXLogger,
    private routingUtils: RoutingUtils
  ) {
    this.paymentLink = environment.subscriptionPaymentLink
  }

  followLink(url: string, pageElement: string): void {
    this.pushClickGtmEvent('subscription_payment_start', pageElement);
    
    // window.open(url, '_blank');

    // const link = document.createElement('a');
    // link.target = '_blank';
    // link.href = url;
    // link.click();
    // link.remove();
  }

  pushClickGtmEvent(event: GtmEvent, pageElement: string): void {
    const element = this.analyticsService.elementNameForRoute(
      this.routingUtils.appRouteFromPath(window.location.pathname),
      pageElement
    );
    this.logger.debug('element', element);

    this.analyticsService.pushEvent(event, {
      category: 'Button Click',
      action: 'Outbound Link',
      element,
    });

  }

  mailtoClick(pageElement: string): void {
    this.pushClickGtmEvent('contact_sales', pageElement);

    // const element = this.analyticsService.elementNameForRoute(
    //   this.routingUtils.appRouteFromPath(window.location.pathname),
    //   pageElement
    // );
    // this.logger.debug('element', element);

    // this.analyticsService.pushEvent('contact_sales', {
    //   category: 'Button Click',
    //   action: 'Outbound Link',
    //   element,
    // });
  }
}
